var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bindElement)?_c('div',[_c('img',_vm._b({},'img',{id:_vm.uuid},false))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }